<template>
  <div>
    <div class="body" v-loading="isLoading">
      <el-table
        ref="singleTable"
        :header-cell-class-name="headerBackgroundColor"
        :row-class-name="rowClass"
        :data="data"
        current-row-key="companyName"
        @filter-change="onTableFilterChange"
        filter-placement="top"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50px"
        >
        </el-table-column>
        <el-table-column
          min-width="80px"
          width="323px"
          show-overflow-tooltip
          label="公司"
          prop="name"
        >
          <template slot="header" slot-scope="scope">
            <div @onScope="scope">
              <div v-if="!isMultiSelectDelete">公司</div>
              <el-button class="multi-select-delete" @click="multiSelectDeleteBtn">取消关注</el-button>
            </div>
          </template>
          <template slot-scope="scope">
            <router-link
              class="router-result-page"
              :to="{name: 'result-page', query: {q: scope.row.name}}"
            >{{scope.row.stock_code}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          width="705px"
          show-overflow-tooltip
          label="分组"
          prop="groups"
        >
          <template slot="header" slot-scope="scope">
            <div @onScope="scope">
              <el-select class="concern-companies-news-list-select" @change="onMonitorCompanyNewsListGroupChange"  v-model="newsListOption" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-for="(item,ind) in scope.row.groups" :key="ind">{{item }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="76px" label="操作">
          <template slot="header" slot-scope="scope">
            <div @onScope="scope">
              <div class="header-title">操作</div>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="operation-class">
              <el-tooltip 
                class="item" 
                effect="dark" 
                content="编辑分组" 
                :visible-arrow="false"
                :enterable="false"
                popper-class="tip"
                placement="bottom-start"
              >
                <i class="edit" @click="onEditBtnClick(scope.row)"></i>
              </el-tooltip>
              <el-tooltip 
                class="item" 
                effect="dark" 
                content="取消关注" 
                :visible-arrow="false"
                :enterable="false"
                popper-class="tip"
                placement="bottom-start"
              >
                <i class="delete" @click="onDeleteBtnClick(scope.row)"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pager" v-if="totalCount > pageSize">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="totalCount">
        </el-pagination>
    </div>
    <el-dialog
      title="取消关注"
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      top="33vh"
    >
      <div class="content">取消关注“{{ companyName }}”？</div>
      <div class="footer" slot="footer">
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="cancel">取消</el-button>
          <el-button class="confirm-btn" @click="onOKDeleteBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="批量取消关注"
      class="delete-dialog"
      :visible.sync="batchDeleteDialogVisible"
      width="400px"
      top="33vh"
    >
      <div class="content">确认取消关注全部选中公司？</div>
      <div class="footer" slot="footer">
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="onBatchDeleteCancelBtn">取消</el-button>
          <el-button class="confirm-btn" @click="onOKBatchDeleteBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import authService from '@/services/authService';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      batchDeleteDialogVisible: false,
      deleteCompanies: [],
      options: [],
      newsListOption: '全部分组',
      isMultiSelectDelete: false,
      timer: null,
      clickPosCount: 0,
      clickNegCount: 0,
      clickTotCount: 0,
      data: [],
      isLoading: false,
      companyName: '',
      groups: [],
      dialogVisible: false,
      totalCount: 0,
      username: '',
      pageNum: 1,
      pageSize: 20,
      queryObj: {
        pageNum: 1,
        pageSize: 30,
        groups: []
      },
      busy: true,
      itemDate: []
    };
  },
  props: {
    tableData: {
      type: Array
    }
  },
  watch: {
    tableData() {
      this.queryObj.pageSize = this.queryObj.pageNum * 30;
      this.queryObj.pageNum = 1;
      this.fetchTableData();
      this.getMonitorGroup();
    }
  },
  methods: {
    refreshData() {
      this.newsListOption = '全部分组';
      this.pageNum = 1;
      this.fetchTableData();
      this.getMonitorGroup();
    },
    onBatchDeleteCancelBtn() {
      this.batchDeleteDialogVisible = false;
      this.$refs.singleTable.clearSelection();
    },
    onOKBatchDeleteBtnClick() {
      questionQuery.deleteMonitorCompanies(this.username, this.deleteCompanies).then(() => {
        this.isMultiSelectDelete = false;
        this.batchDeleteDialogVisible = false;
        this.$refs.singleTable.clearSelection();
        this.$message({
          message: '取消关注成功',
          duration: 1500,
          type: 'success'
        });
        this.fetchTableData();
        this.getMonitorGroup();
      });
    },
    onMonitorCompanyNewsListGroupChange(res) {
      this.pageNum = 1;
      this.newsListOption = res;
      this.fetchTableData();
    },
    multiSelectDeleteBtn() {
      this.batchDeleteDialogVisible = true;
    },
    getMonitorGroup() {
      questionQuery.getMonitorGroup(this.username).then(res => {
        this.options = res.map(item => {
          if (item === '全部') {
            item = '全部分组';
          }
          return {
            value: item,
            label: item
          };
        });
      });
    },
    handleSelectionChange(val) {
      if (val.length) {
        this.isMultiSelectDelete = true;
        this.deleteCompanies = val.map(item => item.name);
      } else {
        this.isMultiSelectDelete = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
    headerBackgroundColor({ rowIndex, columnIndex }) {
      let tmp = null;
      if (rowIndex === 0 && columnIndex === 1 && this.clickPosCount % 3 === 0) {
        tmp = 'header-pos-normal';
      } else if (
        rowIndex === 0 && columnIndex === 1 && this.clickPosCount % 3 === 1
      ) {
        tmp = 'header-pos-up';
      } else if (
        rowIndex === 0 && columnIndex === 1 && this.clickPosCount % 3 === 2
      ) {
        tmp = 'header-pos-down';
      } else if (rowIndex === 0 && columnIndex === 4) {
        tmp = 'header-groups';
      } else if (rowIndex === 0 && columnIndex === 0) {
        tmp = 'header-companies';
      } else if (rowIndex === 0 && columnIndex === 5) {
        tmp = 'header-operation';
      } else if (
        rowIndex === 0 && columnIndex === 2 && this.clickNegCount % 3 === 0
      ) {
        tmp = 'header-neg-normal';
      } else if (
        rowIndex === 0 && columnIndex === 2 && this.clickNegCount % 3 === 1
      ) {
        tmp = 'header-neg-up';
      } else if (
        rowIndex === 0 && columnIndex === 2 && this.clickNegCount % 3 === 2
      ) {
        tmp = 'header-neg-down';
      } else if (
        rowIndex === 0 && columnIndex === 3 && this.clickTotCount % 3 === 0
      ) {
        tmp = 'header-tot-normal';
      } else if (
        rowIndex === 0 && columnIndex === 3 && this.clickTotCount % 3 === 1
      ) {
        tmp = 'header-tot-up';
      } else if (
        rowIndex === 0 && columnIndex === 3 && this.clickTotCount % 3 === 2
      ) {
        tmp = 'header-tot-down';
      }
      return tmp;
    },
    rowClass() {
      return 'row-class';
    },
    handleCurrentChange(res) {
      this.pageNum = res;
      this.fetchTableData();
    },
    fetchTableData() {
      const newsListOptionGroups = this.newsListOption === '全部分组' ? ['全部'] : [this.newsListOption];
      this.isLoading = true;
      questionQuery.getMonitorList(this.username, this.pageNum, this.pageSize, newsListOptionGroups).then(data => {
        this.isLoading = false;
        this.data = data.companies;
        this.busy = false;
        this.itemDate = data.companies;
        this.totalCount = data.total;
      });
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.data.length <= this.totalCount) {
        this.timer = setTimeout(() => {
          this.queryObj.pageNum++;
          this.isLoading = true;
          questionQuery
            .getMonitorList(this.username, this.queryObj)
            .then(data => {
              this.isLoading = false;
              if (data.companies.length) {
                this.busy = false;
                this.data = this.data.concat(data.companies);
              } else {
                this.busy = true;
              }
              this.itemDate = data.companies;
              this.totalCount = data.total;
            });
        }, 500);
      }
    },
    onEditBtnClick(row) {
      this.$emit('onSuggestionItemClick', row);
    },
    onDeleteBtnClick(row) {
      this.dialogVisible = true;
      this.companyName = row.name;
    },
    onOKDeleteBtnClick() {
      questionQuery.deleteMonitor(this.username, this.companyName, []).then(
        () => {
          this.dialogVisible = false;
          this.queryObj.pageSize = 30;
          this.queryObj.pageNum = 1;
          this.fetchTableData();
        },
        () => {
          this.$message.error('取消关注失败！');
        }
      );
    },
    onTableFilterChange(filterObj) {
      const keys = Object.keys(filterObj);
      this.queryObj.groups = filterObj[keys[0]];
      this.queryObj.pageSize = 30;
      this.fetchTableData();
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.fetchTableData();
    this.getMonitorGroup();
  }
};
</script>
<style lang="scss" scoped>
.loading {
  padding-top: 12px;
  height: 40px;
  width: 100%;
  color: #666666;
  text-align: center;
}
.multi-select-delete {
  margin-top: 9px;
  height: 26px;
  width: 80px;
  padding: 0;
  border-radius: 2px;
  border: none;
  font-size: 14px;
  color: #ff5b65;
  background-color: #fff2f3;
  &:hover {
    color: #ff5b65;
    background-color: #ffe7e8;
  }
  &:focus {
    color: #ff5b65;
    background-color: #ffe7e8;
  }
  &:active {
    color: #ff5b65;
    background-color: #ffe7e8;
  }
}
.body {
  width: 100%;
  margin: auto;
  min-height: calc(100vh - 190px);
}
/deep/ .el-table_1_column_1 {
  padding-left: 6px;
}
/deep/ .el-table {
  th.gutter {
    background-color: #3b3a3f;
  }
}
/deep/ .el-table::before {
  background-color: #ffffff;
  height: 0;
  content: "";
}
.router-result-page {
  color: #464d6c;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  &:hover {
    text-decoration: underline;
  }
  .img {
    vertical-align: middle;
    margin-right: 4px;
    margin-bottom: 3px;
  }
}
/deep/ .el-table th div {
  height: 40px;
  line-height: 40px;
  padding-right: 2px;
}
/deep/ .el-table__column-filter-trigger {
  margin-left: 5px;
  .el-icon-arrow-down {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url("../../assets/img/caret-down.svg");
  }
  .el-icon-arrow-up {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url("../../assets/img/caret-up.svg");
  }
}
.header-comp {
  display: inline;
  margin-left: -21px;
  font-family: "DIN-Regular";
}
.arrow-normal {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("../../assets/img/sortArrow-normal.svg");
  vertical-align: middle;
}
.arrow-down {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("../../assets/img/arrow-down-normal.svg");
  vertical-align: middle;
  &:hover {
    background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
  }
}
.arrow-up {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("../../assets/img/arrow-up-normal.svg");
  vertical-align: middle;
}
.comp-pos-cnt {
  color: #fc4a55;
  font-family: "DIN-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.comp-neg-cnt {
  color: #54cea4;
  font-family: "DIN-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.comp-tot-cnt {
  color: #ffffff;
  font-family: "DIN-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.group-filter {
  height: 36px;
  border: solid 2px rgba(69, 168, 204, 0.4);
  border-radius: 2px;
  color: #ffffff;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    border: solid 2px #45a8cc;
  }
  .tag {
    height: 24px;
    line-height: 24px;
    padding: 0 6px;
    margin-right: 4px;
    margin-bottom: 4px;
    border: none;
    border-radius: 2px;
    color: #ffffff;
    font-family: "DIN-Regular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    background-color: rgba(69, 168, 204, 0.2);
  }
}
.header-title {
  color: #747990;
  font-weight: 400;
}
.operation-class {
  display: flex;
  justify-content: space-around;
  .edit {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    background-color: transparent;
    background-image: url("../../assets/img/edit-icon.svg");
    background-size: 100% 100%;
    align-items: center;
    cursor: pointer;
    &:hover {
      background-image: url("../../assets/img/edit-icon-hover.svg");
    }
  }
  .delete {
    display: inline-block;
    margin-left: 12px;
    width: 16px;
    height: 16px;
    background-color: transparent;
    background-image: url("../../assets/img/delete-icon.svg");
    background-size: 100% 100%;
    cursor: pointer;
    &:hover {
      border-radius: 2px;
      background-image: url("../../assets/img/delete-icon-hover.svg");
    }
  }
  .edit-hover {
    height: 24px;
    padding: 3px 17px 5px 0px;
    &:hover {
      border-radius: 2px;
    }
    &:active {
      border-radius: 2px;
    }
    .edit {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/edit-icon.svg");
      background-size: 100% 100%;
      align-items: center;
      cursor: pointer;
      &:hover {
        background-image: url("../../assets/img/edit-icon-hover.svg");
      }
    }
  }
  .delete-hover {
    height: 24px;
    padding: 3px 4px 5px 0px;
    &:hover {
      border-radius: 2px;
    }
    &:active {
      border-radius: 2px;
    }
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/delete-icon.svg");
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        border-radius: 2px;
        background-image: url("../../assets/img/delete-icon-hover.svg");
      }
    }
  }
}
.dialog-delete-monitor {
  margin: 0 6px;
  color: #ffffff;
  font-size: 20px;
}
.dialog-company {
  color: #45a8cc;
  font-size: 20px;
}
.pager {
  display: flex;
  justify-content: center;
  height: 46px;
  margin-top: 26px;
  & /deep/ {
    .el-pagination{
      .btn-prev,
      .btn-next,
      .el-pager .number,
      .el-pager li.btn-quicknext,
      .el-pager li.btn-quickprev,
      .el-icon-more .el-icon-d-arrow-right{
        border-radius:2px;
        border:1px solid rgba(229,230,238,1);
        background: #ffffff;
        min-width: 22px !important;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
      }
      .active{
        border: none;
      }
      .more::before {
        line-height: 22px;
      }
      .el-pagination__jump{
        color: #747990;
        line-height: 22px;
      }
    }
    .el-pagination__editor.el-input .el-input__inner {
      height: 22px;
    }
  }
}
/deep/ .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  height: 32px;
  color: #fff;
}
/deep/ .el-tag {
  border: none;
}
.dialog-body {
  display: flex;
  flex-wrap: wrap;
  .item-list {
    margin-right: 8px;
    margin-bottom: 8px;
    list-style-type: none;
    border-radius: 2px;
    border: solid 2px #605e61;
    &:hover {
      border: solid 2px #45a8cc;
    }
    &:active {
      background-color: rgba(69, 168, 204, 0.1);
      border: solid 2px #45a8cc;
    }
    &:nth-last-child(3) {
      margin-right: 16px;
    }
  }
  .li-back-ground {
    border: solid 2px transparent;
    border-radius: 2px;
    font-family: "DIN-Bold";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    background-color: rgba(69, 168, 204, 0.5);
    &:hover {
      background-color: #45a8cc;
    }
    &:active {
      background-color: rgba(69, 168, 204, 0.4);
    }
  }
  .tag-dialog {
    line-height: 32px;
    padding: 0 12px;
    height: 32px;
    border-radius: 2px;
    color: #ffffff;
    background-color: transparent;
    cursor: pointer;
  }
  .add-group-btn {
    width: 106px;
    height: 36px;
    line-height: 36px;
    padding: 0;
    border: none;
    border-radius: 2px;
    color: #ffffff;
    vertical-align: middle;
    background-color: rgba(225, 225, 225, 0.1);
    cursor: pointer;
    &:hover {
      border: none;
      border-radius: 2px;
      color: #ffffff;
      background-color: #504d52;
    }
    &:active {
      border: none;
      border-radius: 2px;
      background-color: #605c61;
    }
    .plus-circle {
      margin-top: -4px;
      margin-right: 3px;
      vertical-align: middle;
      width: 14px;
    }
  }
  .input-value {
    margin-bottom: 8px;
    align-items: center;
    .input {
      width: 128px;
      height: 36px;
      padding: 15px;
      border: solid 1px #45a8cc;
      border-radius: 2px;
      color: #ffffff;
      background: #27252a;
    }
    .save {
      width: 45px;
      height: 36px;
      padding: 0;
      border: #45a8cc;
      border-radius: 0 !important;
      background: #45a8cc;
      font-family: "DIN-Regular";
      font-size: 14px;
      color: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
    }
    .cancel {
      width: 44px;
      height: 36px;
      margin-left: 4px;
      padding: 0;
      border: rgba(255, 255, 255, 0.1);
      border-radius: 2px;
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
    }
  }
}

/deep/ {
  .header-pos-normal {
    height: 40px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #747990;
    background-color: #ffffff;
  }
  .header-neg-normal {
    height: 40px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #747990;
    background-color: #ffffff;
  }
  .header-companies {
    height: 40px;
    padding: 0 0 0 6px;
    font-size: 14px;
    font-family: "DIN-Regular";
    font-weight: normal;
    font-stretch: normal;
    color: #747990;
    background-color: #ffffff;
    .el-table th div {
      padding-left: 16px !important;
    }
  }
  .row-class {
    height: 40px;
    background-color: #ffffff;
    color: #464d6c;
    &.current-row {
      td {
        background-color: #423f43;
      }
    }
  }
  .el-table {
    background-color: #ffffff;
    padding: 0 24px;
  }
  .el-table td,
  .el-table th.is-leaf {
    height: 40px;
    box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    border: none;
  }
  .el-table th.is-leaf {
    border-bottom: none;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #f7f8fc !important;
  }
  .el-table__empty-block {
    background-color: #ffffff;
    .el-table__empty-text {
      color: #464d6c;
    }
  }
  .delete-dialog {
    .el-dialog {
      background-color: #ffffff;
      border-radius: 0;
      width: 400px;
      height: 229px;
      position: relative;
      .el-dialog__headerbtn {
        top: 14px;
      }
      .el-dialog__header {
        height: 44px;
        width: 100%;
        box-shadow: inset 0px -1px 0px 0px #f7f7fa;
        padding: 0 24px;
        .el-dialog__title {
          color: #171f46;
          font-size: 14px;
          line-height: 44px;
        }
      }
      .el-dialog__body {
        padding: 24px;
        margin-top: 44px;
        color: #747990;
        font-size: 14px;
        line-height: 22px;
      }
      .el-dialog__footer {
        width: 100%;
        height: 64px;
        background-color: #ffffff;
        box-shadow: inset 0px 1px 0px 0px #f7f7fa;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 16px 0;
        .footer-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 136px;
          height: 32px;
          .cancel-btn {
            height: 32px;
            width: 60px;
            padding: 0;
            font-size: 14px;
            color: #464d6c;
            background-color: #f7f8fc;
            border-radius: 2px;
            border: none;
            &:hover {
              color: #464d6c;
              background-color: #eaeaed;
            }
            &:focus {
              color: #464d6c;
              background-color: #eaeaed;
            }
            &:active {
              color: #464d6c;
              background-color: #eaeaed;
            }
          }
          .confirm-btn {
            height: 32px;
            width: 60px;
            padding: 0;
            font-size: 14px;
            color: #ffffff;
            background-color: #45a8cc;
            margin-left: 16px;
            border-radius: 2px;
            border: none;
            &:hover {
              color: #ffffff;
              background-color: #3e97b8;
            }
            &:focus {
              color: #ffffff;
              background-color: #3e97b8;
            }
            &:active {
              color: #ffffff;
              background-color: #3e97b8;
            }
          }
        }
      }
    }
  }
}
a {
  text-decoration: none;
}
.router-link-active {
  text-decoration: none;
}
/deep/ .el-tag {
  height: 20px;
  background-color: #f7f8fc;
  border-radius: 2px;
  padding: 0px 8px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #464d6c;
  transition: none;
  margin-right: 5px;
}
.edit-hover-title {
  position: relative;
  top: 20px;
}
/deep/.el-select .el-input__inner {
  height: 26px;
  width: 150px;
  border: none !important; 
  border-radius: 2px;
  color: #747990;
  background-color: #ffffff !important;
  font-size: 14px;
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}
</style>
<style lang="scss">
.more-data{
    padding-bottom: 20px;
}
.el-table-filter {
  margin-left: 46px !important;
  margin-top: 8px !important;
  border: none !important;
  border-radius: 4px !important;
  background-color: #17171b !important;
  .el-table-filter__content {
    background-color: #17171b;
    min-width: 152px;
    .el-table-filter__checkbox-group {
      padding: 0;
      .el-checkbox:hover {
        background-color: #222227;
      }
    }
    .el-table-filter__bottom button {
      color: #ffffff;
      &:hover {
        display: block;
        height: 52px;
        width: 32px;
        background-color: #423f43;
        border-radius: 2px;
      }
    }
    .el-checkbox {
      height: 32px;
      line-height: 32px;
      margin: 0 13px;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #ffffff;
    }
    .el-checkbox__label {
      color: #ffffff;
    }
    .el-checkbox__inner {
      background-color: #17171b;
      border: 1px solid rgba(225, 225, 225, 0.3);
    }
  }
  .el-table-filter__bottom {
    border-top: 1px solid #3b3a3f;
    .is-disabled {
      color: #000;
    }
  }
}
.el-popover.el-popper.tip {
  width: 3px;
  height: 4px;
  color: transparent;
  border: none;
  font-size: 12px;
  background-color: transparent;
  box-shadow: none;
  /deep/ .edit-hover-title {
    position: relative;
    top: -20px;
    left: -5px;
    width: 56px;
    height: 26px;
    background-color: #3d414f;
    border-radius: 2px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #ffffff;
    padding: 4px;
  }
  /deep/ .delete-hover-title {
    position: relative;
    top: -20px;
    left: -5px;
    width: 56px;
    height: 26px;
    background-color: #3d414f;
    border-radius: 2px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #ffffff;
    padding: 4px;
  }
}
.el-tooltip__popper.is-dark.tip {
  padding: 4px;
  border-radius: 2px;
  color: #ffffff;
  font-size: 12px;
  background-color: #3d414f;
}
</style>
